import { HEADER_MOBILE_BREAKPOINT } from '../config/breakpoints';

const megaMenu = () => {
  let lastStickyState = null; // Cache sticky state to prevent flicker

  showFirstMenu();
  showMegaMenu();
  hideMegaMenu();
  delayHeader();
  applyStickyHeader();
  stickyBar();
  setActiveLink();
  setSecondActiveLink();
  updateMegaMenuDropdownTop();
  $(window).on('resize', updateMegaMenuDropdownTop);

  /**
   * updateMegaMenuDropdownTop
   * The mega menu dropdown (.mega-menu__content) is positioned relative to
   * .header-wrapper, which also contains the second-row sublevel bar
   * (e.g. Order's What's New / Deals / Baking). Anchoring it with `top: 100%`
   * would push it below that second row too, instead of overlaying it. This
   * measures the real bottom edge of the first-row nav and exposes it as a
   * CSS var so the dropdown can sit right under the first row only, on top
   * of the second row, regardless of it staying visible.
   */
  function updateMegaMenuDropdownTop() {
    const headerWrapper = document.querySelector('.mrHeader-wrapper');
    const inlineMenu = document.querySelector('.header__inline-menu');
    if (!headerWrapper || !inlineMenu) return;
    const top = inlineMenu.getBoundingClientRect().bottom
      - headerWrapper.getBoundingClientRect().top;
    if (top > 0) {
      headerWrapper.style.setProperty('--mega-menu-dropdown-top', `${top + 1}px`);
    }
  }

  // delay header
  function delayHeader() {
    const tempInterval = setInterval(() => {
      setTimeout(() => {
        const header = document.querySelector('header.mrHeader');
        const mobileHeader = document.querySelector(
          '.mrMobiMenu-simpleNav-container',
        );

        header.style.display = 'block';
        if ($(window).width() <= 768) {
          mobileHeader.style.display = 'block';
        }
      }, 200);
    }, 200);

    setTimeout(() => {
      clearInterval(tempInterval);
    }, 500);
  }

  /**
   * showMegaMenu
   * the category link with sub-categories will trigger to show mega menu
   */

  function showMegaMenu() {
    $('body').on('mouseenter', '.mrMega-menu-linkWithChild', (e) => {
      updateMegaMenuDropdownTop();
      const headerMenuIndex = $(e.currentTarget).attr('data-header-menu-index');
      const currentEle = $(`#Details-HeaderMenu-${headerMenuIndex}`);
      $('.mrMega-menu-container').removeClass('show');
      currentEle.addClass('show');

      // Hovering a top-level item (e.g. Our Brands / News / Resources / FAQs)
      // only opens that item's own mega menu - it must not touch the
      // second-row sublevel bar (e.g. Order's What's New / Deals / Baking),
      // which should keep showing whatever tab was already active so the
      // header doesn't jump/shift when it hides and reappears.
    });
  }

  /**
   * hideMegaMenu
   * will hide mega menu when:
   *  scrolling the page (this is temperorily stoped)
   *  hovering on the category link without sub-categories
   *  hovering on unrelevant elements
   */
  function hideMegaMenu() {
    $(window).on('scroll', () => {
      $('.mrMega-menu-container').removeClass('show');
    });
    $('body').on('mouseenter', '.mrMega-menu-linkWithoutChild', () => {
      $('.mrMega-menu-container').removeClass('show');
    });
    $('body').on('mouseout', (e) => {
      const currentEle = $(e.target);
      if (!currentEle.attr('data-mega-hide')) {
        if (!currentEle.hasClass('header--extra-wrapper')) {
          $('.mrMega-menu-container').removeClass('show');
        }
        if (
          !currentEle.parents('header.mrHeader').length &&
          $('[data-collection-filters] .sticky').length <= 0
        ) {
          showFirstMenu();
        }
      }
    });
  }

  /* $(document).on('mouseover', (event) => {
        if ($(event.target).closest('sticky-header').length <=0  && $(event.target).is('sticky-header') === false) {
            $('sticky-header').find('ul').removeClass('show');
        }
    }) */

  $('body').on('mouseenter', '.mrMega-menu-link__top', function () {
    const handle = $(this).data('handle');
    const $targetSublevel = $(`.mrMega-menu-sublevel-container--${handle}`);

    // Some top-level items (e.g. FAQs) have no sublevel bar of their own -
    // there's nothing to switch to, so leave whichever tab (e.g. Order) is
    // already showing untouched instead of hiding it with nothing to
    // replace it.
    if ($targetSublevel.length === 0) {
      return;
    }

    $('.mrMega-menu-link__top').removeClass('header__menu-item--active');
    $('.mrMega-menu-sublevel-container').removeClass('sticky-hidden');
    $(this).addClass('header__menu-item--active');
    $('.mrMega-menu-sublevel-container').removeClass('show');
    $targetSublevel.addClass('show');
  });

  $('[data-mobile-target]').on('click', function () {
    const target = $(this).attr('data-mobile-target');
    $('.mrMobiMenu-innerContainer-level2').addClass('is-open');
    $('.mrMobiMenu-innerContainer-level2 .mrMobiMenu-listItem[data-id]').hide();
    $(
      `.mrMobiMenu-innerContainer-level2 .mrMobiMenu-listItem[data-id="${target}"]`,
    ).show();
  });

  $('.mrMobiMenu-listItem-parentTitle').on('click', function () {
    $('.mrMobiMenu-innerContainer-level2').removeClass('is-open');
  });

  function showFirstMenu() {
    if ($(window).width() > HEADER_MOBILE_BREAKPOINT) {
      const handle = $('.list-menu.list-menu--inline li')
        .first()
        .find('.mrMega-menu-link__top')
        .data('handle');
      $('.mrMega-menu-link__top').removeClass('header__menu-item--active');
      $('.mrMega-menu-sublevel-container').removeClass('show');
      $(`.mrMega-menu-link__top[data-handle=${handle}]`).addClass(
        'header__menu-item--active',
      );
      $(`.mrMega-menu-sublevel-container--${handle}`).addClass('show');
    }
  }

  // show second menu bar when scrolled up, hide when scrolled down
  function applyStickyHeader() {
    let lastScrollTop = 0;
    let scrollDirection = 'none';
    $(window).on('scroll', (e) => {
      const scrollTop = $(window).scrollTop();

      collectionFacets();

      // Determine scroll direction
      if (scrollTop > lastScrollTop && scrollDirection !== 'down') {
        scrollDirection = 'down';
      } else if (scrollTop < lastScrollTop && scrollDirection !== 'up') {
        scrollDirection = 'up';
      }

      // Commented out: scroll-based menu show/hide was interfering with other functions
      // if (scrollTop > lastScrollTop) {
      //   // scrolling down
      //   $('.mrMega-menu-sublevel-container').removeClass('show').addClass('sticky-hidden');
      //   showFirstMenu();
      // } else {
      //   // scrolling up
      //   $('.mrMega-menu-sublevel-container').removeClass('sticky-hidden').addClass('show');
      // }
      
      lastScrollTop = scrollTop;
    });
  }

  function collectionFacets() {
    if ($('.facets-container').length) {
      const facetsContainer = $('.facets-container')[0];
      
      // Store original position on first call (when page loads, before any scrolling)
      // Only set if not sticky, to get the true document position
      if (!facetsContainer.dataset.originalTop && !facetsContainer.classList.contains('sticky')) {
        const rect = facetsContainer.getBoundingClientRect();
        facetsContainer.dataset.originalTop = rect.top + window.pageYOffset;
      }
      
      const originalTop = parseFloat(facetsContainer.dataset.originalTop) || 0;
      
      // Get header elements for positioning
      const headerSection = document.querySelector('#shopify-section-header');
      const headerWrapper = document.querySelector('.mrHeader-wrapper');
      
      // Calculate stable header height for threshold (use offsetHeight which doesn't change with scroll)
      let headerHeight = 0;
      if (headerWrapper) {
        headerHeight = headerWrapper.offsetHeight;
        // Also add announcement bar height if it's sticky
        const announcementBar = document.querySelector('.mrAnnouncement-container.sticky-bar');
        if (announcementBar) {
          headerHeight += announcementBar.offsetHeight;
        }
      }
      
      // Element should become sticky when we've scrolled past its original position minus header height
      const shouldBeSticky = window.scrollY >= originalTop - headerHeight;
      
      // Calculate actual top position for sticky state (use current viewport position)
      let stickyTop = 0;
      if (headerSection) {
        stickyTop = headerSection.getBoundingClientRect().bottom;
      } else if (headerWrapper) {
        stickyTop = headerWrapper.getBoundingClientRect().bottom;
      }
      
      // Only update DOM if state actually changed to prevent flicker
      if (lastStickyState !== shouldBeSticky) {
        lastStickyState = shouldBeSticky;
        
        if (shouldBeSticky) {
          $('.facets-container').css('top', stickyTop);
          $('.buttons-container').css('top', stickyTop);
          $('.buttons-container').addClass('sticky');
          $('.facets-container').addClass('sticky');
        } else {
          $('.buttons-container').removeClass('sticky');
          $('.facets-container').removeClass('sticky');
          // Reset top when not sticky
          $('.facets-container').css('top', '');
          $('.buttons-container').css('top', '');
        }
      } else if (shouldBeSticky) {
        // State unchanged but sticky - update top value in case header height changed
        $('.facets-container').css('top', stickyTop);
        $('.buttons-container').css('top', stickyTop);
      }
    }
  }

  function stickyBar() {
    $(window).scroll(function () {
      if (
        !$('.mrAnnouncement-container').length ||
        !$('.mrAnnouncement-container').hasClass('sticky-bar')
      ) {
        $('.mrHeader').css('margin-top', '0');
        $('#shopify-section-announcement-bar').css({
          height: '0',
          display: 'none',
        });
        return;
      }

      const scrollDistance = $(window).scrollTop();
      if (
        $('#shopify-section-announcement-bar').is(':visible') === true ||
        $('#shopify-section-announcement-bar').height() > 0
      ) {
        if (scrollDistance >= 5) {
          const announcementBarHeight = $('#shopify-section-announcement-bar').height();
          $('.mrHeader').css('margin-top', announcementBarHeight + 'px');
          $('#shopify-section-announcement-bar').css('top', '0');
        } else {
          $('.mrHeader').css('margin-top', '0');
        }
      }
    });
  }

  function setActiveLink() {
    if (window.location.pathname.startsWith('/collections/')) {
      // Get the current page h1 collection__custom-title
      const currentPageTitle = document.querySelector(
        'h1.collection__custom-title',
      );

      // Get all the elements with class 'mrHeader-linkItem'
      const linkItems = document.getElementsByClassName('mrHeader-linkItem');

      // Loop through each link item
      for (let i = 0; i < linkItems.length; i++) {
        const linkItem = linkItems[i];

        // Check if the link item text matches the current page title
        if (linkItem.innerText === currentPageTitle.innerText) {
          // Add the class 'active-link' to the parent element with class 'header__menu-item'
          const parentElement = linkItem.closest('.header__menu-item');
          if (parentElement) {
            parentElement.classList.add('active-link');
          }
        }
      }
    }
  }

  function setSecondActiveLink() {
    if (window.location.pathname.startsWith('/collections/')) {
      // Check if .header__active-menu-item exists
      const activeMenuItem = document.querySelector(
        '.header__active-menu-item',
      );

      if (activeMenuItem) {
        // Add the class 'active-link' to the parent element with class 'header__menu-item'
        const parentElement = activeMenuItem.closest('.header__menu-item');
        if (parentElement) {
          parentElement.classList.add('active-link');
        }
      }
    }
  }
};

export default megaMenu;
